<script setup>
  import {
    couponRef,
    deleteDocument,
  } from "@/firebase/firebase";
  import { query, where } from "firebase/firestore";
  import { useCollection } from "vuefire";

  const coupons = useCollection(
    query(
      couponRef,
      where("used", "==", false),
    ),
    { ssrKey: "coupon" }
  );

  const deleteData = async function (coupon) {
    await deleteDocument(couponRef, coupon.id);
  };

</script>

<template>
  <div v-if="coupons.length">
    <v-card class="mx-auto mt-9 mb-9 pa-md-4 ms-2 me-2" v-for="(coupon, i) in coupons" :key="i">

      <v-row align="center ma-2">
        <v-col cols="6">
          <div class="text-no-wrap secondary" style="width: 8rem;">
            コード：{{ coupon.coupon_code }} <br>
            有効日：{{ coupon.expire }} 日
          </div>
        </v-col>
        <v-col cols="6" style="text-align-last: end;">
          <v-btn class="ml-5 mr-5" color="red" @click="deleteData(coupon)">
            取消
          </v-btn>
        </v-col>
      </v-row>
    </v-card>
  </div>

  <div v-else class="mx-auto mt-9 ml-9">
    <span>現在発行しているクーポンはありません </span>
  </div>
</template>
